// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26EWz","label":"styles_label__3e1L3"};